import React from "react";
import l from "components/util/l";

// Section titles follow the "ID - Section - Submodule" convention, which is what turns a
// flat list of sections into a two-level index. A title that does not follow it still gets
// an entry, standing on its own under its raw title.
const parseSectionTitle = (title, fallbackIndex) => {
  const parts = String(title || "").split(" - ");

  if (parts.length >= 3) {
    return {
      id: parts[0],
      sectionName: parts[1],
      submoduleName: parts.slice(2).join(" - "),
    };
  }

  return {
    id: `[${fallbackIndex + 1}]`,
    sectionName: title || l("Sin título%PA841"),
    submoduleName: title || l("Sin título%PA841"),
  };
};

const buildIndexGroups = (sections) => {
  const groups = [];
  const groupIndexByName = {};

  sections.forEach((section, index) => {
    const parsed = parseSectionTitle(section.title, index);
    const groupIndex = groupIndexByName[parsed.sectionName];
    const item = {
      ...parsed,
      stepIndex: section.stepIndex,
    };

    if (groupIndex != null) {
      groups[groupIndex].items.push(item);
      return;
    }

    groupIndexByName[parsed.sectionName] = groups.length;
    groups.push({
      name: parsed.sectionName,
      items: [item],
    });
  });

  return groups;
};

const RevisionIndex = ({
  sections,
  onClickSelectSection,
}) => {

  const groups = buildIndexGroups(sections);

  return (
    <div className="col-12 h-auto d-flex flex-column overflow-hidden" style={{ maxWidth: "68rem", borderRadius: "1.5rem" }}>
      <div className="flex-fill d-flex flex-column animate__animated animate__fadeInUp px-3 px-md-4 py-4">
        <div className="overflow-hidden">
          <div className="px-1 px-md-2 py-4 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded text-white mr-3"
                style={{
                  width: "44px",
                  height: "44px",
                  flexShrink: 0,
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.16)",
                }}
              >
                <i className="fas fa-list-ul"></i>
              </div>
              <div>
                <h2 className="font-weight-bold text-white mb-0" style={{ fontSize: "1.65rem" }}>{l("Índice%PA839")}</h2>
              </div>
            </div>

            <div className="d-none d-md-flex align-items-center justify-content-center rounded-circle text-white font-weight-bold"
              style={{
                width: "40px",
                height: "40px",
                fontSize: "0.9rem",
                background: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.16)",
              }}>
              {sections.length}
            </div>
          </div>

          <div className="py-2">
            {groups.map((group, groupIndex) => (
              <section
                key={group.name}
                className="py-4"
                style={{ borderTop: groupIndex === 0 ? "0" : "1px solid rgba(255,255,255,0.1)" }}
              >
                <div className="d-flex">
                  <div
                    className="rounded mr-3"
                    style={{ width: "4px", minHeight: "32px", flexShrink: 0, background: "rgba(255,255,255,0.45)" }}
                  />
                  <div className="flex-fill" style={{ minWidth: 0 }}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h5 className="font-weight-bold mb-0 text-white" style={{ fontSize: "1.05rem" }}>
                        {group.name}
                      </h5>
                      <span className="badge text-white font-weight-bold" style={{ background: "rgba(255,255,255,0.12)" }}>
                        {group.items.length}
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      {group.items.map((item) => (
                        <button
                          key={`${item.stepIndex}-${item.id}-${item.submoduleName}`}
                          type="button"
                          className="btn text-left d-flex align-items-center justify-content-between mb-2 px-3 py-3"
                          style={{ borderRadius: "8px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.12)" }}
                          onClick={() => onClickSelectSection(item.stepIndex)}
                        >
                          <span className="d-flex align-items-center overflow-hidden" style={{ minWidth: 0 }}>
                            <span
                              className="badge text-white font-weight-bold mr-3"
                              style={{
                                flexShrink: 0,
                                fontSize: "0.78rem",
                                background: "rgba(255,255,255,0.14)",
                                border: "1px solid rgba(255,255,255,0.16)",
                              }}
                            >
                              {item.id}
                            </span>
                            <span className="text-white text-truncate">
                              {item.submoduleName}
                            </span>
                          </span>
                          <i className="fas fa-chevron-right text-white-50 ml-3" style={{ fontSize: "0.75rem", flexShrink: 0 }}></i>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

};

export default RevisionIndex;
